"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDynamicCodeForLoginRequest = void 0;
var GetDynamicCodeForLoginRequest = /** @class */ (function () {
    function GetDynamicCodeForLoginRequest() {
    }
    return GetDynamicCodeForLoginRequest;
}());
exports.GetDynamicCodeForLoginRequest = GetDynamicCodeForLoginRequest;
;
//# sourceMappingURL=getDynamicCodeForLogin.request.js.map